import { render, staticRenderFns } from "./AddQuickCommentDialog.vue?vue&type=template&id=b1d74898"
import script from "./AddQuickCommentDialog.vue?vue&type=script&lang=js"
export * from "./AddQuickCommentDialog.vue?vue&type=script&lang=js"
import style0 from "./AddQuickCommentDialog.vue?vue&type=style&index=0&id=b1d74898&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports